module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.speaker) ? _c('div', {
    staticClass: "speaker columns is-flex"
  }, [_c('div', {
    staticClass: "column columns is-offset-one-quarter is-half"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSpeaker(_vm.speaker.id)
      }
    }
  }), _vm._v(" "), (_vm.speaker.type === 'speaker') ? _c('div', {
    staticClass: "speaker-data"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.speaker.title),
      callback: function($$v) {
        _vm.$set(_vm.speaker, "title", $$v)
      },
      expression: "speaker.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Имя спикера",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.speaker.name),
      callback: function($$v) {
        _vm.$set(_vm.speaker, "name", $$v)
      },
      expression: "speaker.name"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('Editor', {
    attrs: {
      "id": 'speaker-editor-' + _vm.speaker.id,
      "placeholder": "Текст информации",
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)], 1) : _c('div', {
    staticClass: "speaker-data"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Подзаголовок"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.speaker.title),
      callback: function($$v) {
        _vm.$set(_vm.speaker, "title", $$v)
      },
      expression: "speaker.title"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('input', {
    ref: "loadSpeakerPhotoButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.callLoadSpeakerPhoto
    }
  }), _vm._v(" "), (_vm.speaker.type === 'speaker') ? _c('div', [(!_vm.speaker.photo && !_vm.base64photo) ? _c('div', {
    staticClass: "rounded-photo-wrapper centered speaker-photo",
    on: {
      "click": function($event) {
        return _vm.$refs.loadSpeakerPhotoButton.click()
      }
    }
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "speaker-photo",
    style: ((_vm.base64photo) ? 'background: url(' + _vm.base64photo + ')' : 'background: url(/upload/photos/' + _vm.speaker.photo)
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSpeakerPhoto(_vm.speaker.id)
      }
    }
  })])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Сменить фото")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42880076"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/EventItemSpeaker.vue
// module id = 938
// module chunks = 0